'use client';

import * as Sentry from '@sentry/nextjs';
import { useEffect } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { analyticsTrack } from '@/utils/analytics';

function CrashView() {
  return (
    <Container className="container mt-3 mb-5 pt-2 pb-5 text--justify">
      <Row className="container">
        <Col
          xs={12}
          md={12}
        >
          <h1 className="text--orange title--h2 pb-3">Something went wrong</h1>
        </Col>
        <Col
          xs={12}
          md={12}
        >
          <p>
            {'Please refresh the page to keep using the app. Need help? '}
            <a href="mailto:support@l1.co">Get in touch with our team</a>.
          </p>
        </Col>
      </Row>
    </Container>
  );
}

export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
  useEffect(() => {
    try {
      Sentry.captureException(error);
      analyticsTrack('Got a Crash', {
        path: window.location.pathname,
        error: error.toString(),
      });
    } catch (e) {
      console.error('Error while capturing exception via Sentry', e);
    }
  }, [error]);

  return <CrashView />;
}
